<section class="eventsection-details__details">
  <div class="mdc-layout-grid eventsection-details__flowsection">
    <div class="mdc-layout-grid__inner">
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <h2 class="eventsection-details__headline mat-headline-2" i18n="@@featureEventDetails-exhibitorContactHeadline"
          >Aussteller &amp; Kontakt</h2
        >
        <planone-contact-exhibitor
          [hideDescription]="true"
          [hideLocation]="(hallPlanToggle$ | async) === false || (hallPlanActive$ | async) === false"
          [exhibitor]="exhibitor"
          [exhibitorClickable]="exhibitorClickable"
          (linkClick)="trackClick($event.element, $event.linkType, $event.linkText)"></planone-contact-exhibitor>
        <bau365-channel-subscribe-button
          [entityId]="exhibitor?.id"
          [fairId]="exhibitor?.fair_id"
          [context]="'event-details'"></bau365-channel-subscribe-button>
      </div>
    </div>
  </div>
</section>
